import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";

function SuccessCompletePayment() {
  const { t } = useTranslation();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <Button
        onClick={() => {}}
        label={t("transparentDrawer.button.getMyReceipt")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={() => {}}
        label={`${t("transparentDrawer.button.backToTheBillAndPay")} $ 9.99`}
        variant="outlined"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default SuccessCompletePayment;
